import { Component, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { CommonModule } from '@angular/common';
import { InvitesService } from 'src/app/dashboard/services/invites.service';
import { Invite, InviteType } from 'src/app/dashboard/models/invite';
import { UserStore } from 'src/app/shared/user/store/user.store';
import { PermissionCode } from 'src/app/shared/user/models/permission';

@Component({
  selector: 'app-invites',
  standalone: true,
  imports: [CommonModule, ButtonModule, CardModule, ToastModule],
  providers: [MessageService],
  templateUrl: './invites.component.html',
  styleUrl: './invites.component.css'
})
export class InvitesComponent {
  private inviteService = inject(InvitesService);
  private messageService = inject(MessageService);
  private userStore = inject(UserStore);
  private router = inject(Router);

  invites = computed(() => this.inviteService.invites());

  acceptInvite(invite: Invite) {
    const moduleDescription = invite.type === InviteType.VendorCatalog
      ? 'necta.supply'
      : 'necta.one';

    const hadReportsAccessBefore =
      this.userStore.isRegisteredNectaOne() === true
      && this.userStore.hasPermission(PermissionCode.Reports);

    this.inviteService.acceptInvite(invite).subscribe(() => {
      this.inviteService.invites.update(list =>
        list.filter(i => i.id !== invite.id),
      );

      this.userStore.checkRegistrations().subscribe(() => {
        this.userStore.triggerDashboardRefresh();

        const hasReportsAccessAfter =
          this.userStore.isRegisteredNectaOne() === true
          && this.userStore.hasPermission(PermissionCode.Reports);

        if (hadReportsAccessBefore !== hasReportsAccessAfter) {
          this.router.navigateByUrl(this.router.url, { skipLocationChange: true });
        }
      });

      this.messageService.add({
        severity: 'success',
        summary: 'Einladung akzeptiert',
        detail: `Einladung zum Modul ${moduleDescription} wurde erfolgreich angenommen.`,
      });
    });
  }

  rejectInvite(invite: Invite) {
    this.inviteService.rejectInvite(invite.id, invite.type).subscribe(() => {
      this.messageService.add({
        severity: 'warn',
        summary: 'Einladung abgelehnt',
        detail: `Einladung ${invite.id} wurde abgelehnt.`,
      });
    });
  }
}
